import { ReactElement, ReactNode } from "react";

/**
 * The properties for a {@link SettingsRow} component.
 */
interface ISettingsRowProps {
    /**
     * The label to display.
     */
    title: ReactNode;

    /**
     * The child components to render.
     */
    children: ReactNode;
}

/**
 * A generic settings row component that displays a title and renders child components.
 */
function SettingsRow({ title, children }: Readonly<ISettingsRowProps>): ReactElement {
    return (
        <div className="row">
            <div className="hidden-sm hidden-xs col-md-2 col-lg-2 text-right">
                <div className="form-label bold">{title}</div>
            </div>
            <div className="col-sm-12 col-md-10 col-lg-10">
                <div className="row native">
                    <div className="col-sm-12 col-md-10 col-lg-5 nopadding">
                        <div className="visible-xs bold visible-sm">{title}</div>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SettingsRow;
